import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { fundOwnershipUrl } from 'common/config/urls';
import { EmptyTableMessage } from 'components';
import GoToFundOwnership from 'pages/Waterfall/components/GoToFundOwnership';
import { NeedsFundOwnershipFirstProps } from './NeedsFundOwnershipFirst.props';

const FUND_OWNERSHIP_TABLE_TERMS = {
  tableName: 'Fund Ownership',
  tableSlug: 'fund-ownership',
  columnName: 'Ownership',
  pluralColumnName: 'Ownership',
};

const NeedsFundOwnershipFirst = ({
  fundOwnershipURL,
  measurementDates,
  selectedMeasurementDate,
  title,
  tagline,
}: NeedsFundOwnershipFirstProps) => {
  const { firmSlugParam, companySlugParam } = useParams<{
    companySlugParam?: string;
    firmSlugParam?: string;
  }>();

  const resolvedFundOwnershipURL =
    fundOwnershipURL ?? (firmSlugParam && companySlugParam ? fundOwnershipUrl(firmSlugParam, companySlugParam) : null);
  const measurementDateSlug = useMemo(
    () =>
      selectedMeasurementDate?.slug
      ?? (measurementDates || []).find(md => Number(md.id) === Number(selectedMeasurementDate?.id))?.slug
      ?? '',
    [measurementDates, selectedMeasurementDate?.id, selectedMeasurementDate?.slug]
  );

  return (
    <EmptyTableMessage
      tableTerms={FUND_OWNERSHIP_TABLE_TERMS}
      component={
        resolvedFundOwnershipURL ? (
          <GoToFundOwnership fundOwnershipURL={resolvedFundOwnershipURL} measurementDateSlug={measurementDateSlug} />
        ) : undefined
      }
      title={title}
      tagline={tagline}
    />
  );
};

export default NeedsFundOwnershipFirst;
